import { format } from "date-fns";
import { DialerSeatLine } from "@/model/interface/AddOn";

export function formatAddOnPrice(cents: number): string {
  if (cents === 0) {
    return "Free";
  }
  const dollars = cents / 100;
  return `$${Number.isInteger(dollars) ? dollars : dollars.toFixed(2)}`;
}

export function formatPeriodEnd(seconds?: number, pattern = "MMM d, yyyy"): string | null {
  if (!seconds) {
    return null;
  }
  return format(new Date(seconds * 1000), pattern);
}

export function renewingSeats(line: DialerSeatLine): number {
  return line.canceling ? 0 : line.quantity;
}

export function seatCount(seats: number, kind: string): string {
  return `${seats} ${kind} ${seats === 1 ? "seat" : "seats"}`;
}
